/**
 * Validate a `returnTo` target so we only ever redirect to a safe, in-app path.
 * Accepts root-relative paths within the help area; rejects protocol-relative
 * (`//evil.com`), absolute URLs, and anything not starting with `/help/`.
 * Returns the safe path, or null if it must not be used.
 */
export function sanitizeReturnTo(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (raw.startsWith('//')) return null;      // protocol-relative
  if (!raw.startsWith('/help/')) return null; // root-relative + scoped to help
  return raw;
}
